export enum APPLICATION_ROUTES {
  PATIENT_ROOT = '/patients',
  LOGOUT_INACTIVITY = '/logout-inactivity',
  LOGIN = '/login',
  PSEUDONYM_APPOINTMENTS = '/patients/pseudonym-appointment',
  MATERIAL_EDUCATIONAL = '/patients/material-educational',
  MATERIAL_EDUCATIONAL_DETAIL = '/patients/material-educational/:nrSequence',
  NEW_APPOINTMENT_PATIENT = '/patients/appointments/new-appointment',
  PSEUDONYM_APPOINTMENT_FORM = '/patients/appointments/pseudonym-appointment-form',
  EXAMS = '/patients/exams',
  EXAM_DETAILS = '/patients/exams/nonlab/details',
  EXAM_LAB_DETAILS = '/patients/exams/lab/details',
  APPOINTMENT_DETAIL = '/patients/appointments/:appointmentType/:nrSeq',
  PSEUDONYM_APPOINTMENT_DETAIL = '/patients/pseudonym-appointments/detail/type/:appointmentType/record/:nrSeq',
  HOME_DASHBOARD = '/patients/dashboard',
  FORGET_PASSWORD = '/login/forget-password',
  CONFIRM_PASSWORD = '/forget-password-request-success',
  TERMS_OF_USE_MODAL = '/patients/privacy/terms/:nrSeqTermo/:termType',
  PRIVACY_MODAL = '/patients/privacy/privacy-notice/:nrSeqAviso',
  ASSIGN_TERMS_OF_USE = '/terms-of-use/:nrSeqTermo/type/:termType',
  ASSIGN_PRIVACY = '/privacy/:nrSeqTermo',
  FORGET_PASSWORD_REQUEST_SUCCESS = '/forget-password/success',
  RESET_PASSWORD = '/reset-password',
  FORGET_PASSWORD_RESET_SUCCESS = '/reset-password-success',
  FORGET_PASSWORD_RESET_FAILURE = '/reset-password-failure',
  PROFILE = '/patients/profile',
  GUIDANCE_AND_REGULATORY = '/patients/guidance-and-regulatory-modal',
  CHANGE_PASSWORD = '/login/change-password',
  PROFILE_CHANGE_PASSWORD = '/patients/change-password',
  ACCOUNT_CREATION_MODAL = '/login/create-new-user',
  ACCOUNT_CREATION_COMPLETED = '/login/create-new-user/completed',
  ACCOUNT_CREATION_PROCESSING = '/login/create-new-user/processing',
  PROFILE_PRIVACY = '/patients/privacy',
  COOKIE_POLICY = '/login/cookie-policy',
  VERSION = '/version',
  ACTIVATE = '/activate',
  REACTIVATE = '/resend-link/:token',
  RESCHEDULE_APPOINTMENTS = '/patients/appointments/reschedule',
  RESCHEDULE_CHECKUP = '/patients/appointments/reschedule/checkup',

  // My Chart
  MY_CHART = '/patients/my-chart',
  MY_CHART_ALLERGIES = '/patients/my-chart/allergies',
  MY_CHART_ALLERGIE_DETAIL = '/patients/my-chart/allergies/detail/:nrSequence/tab/:tab',
  MY_CHART_ALLERGIE_NEW = '/patients/my-chart/allergie/new',
  MY_CHART_PRESCRIPTIONS = '/patients/my-chart/prescriptions',
  MY_CHART_SICK_NOTE = '/patients/my-chart/sick-note',
  MY_CHART_MEDICINE_DETAIL = '/patients/my-chart/medicine-detail/:nrSequence',
  MY_CHART_MEDICINES_IN_USE = '/patients/my-chart/medicines-in-use',
  MY_CHART_SENDING_DOCUMENTS = '/patients/my-chart/sending-documents',
  MY_CHART_NEW_DOCUMENT = '/patients/my-chart/sending-documents/new',
  MY_CHART_DISCHARGE_SUMMARY = '/patients/my-chart/discharge-summary',
  MY_CHART_TELEHEALTH_RECORDS = '/patients/my-chart/telehealth-records',
  MY_CHART_DISCHARGE_SUMMARY_DETAILS = '/patients/my-chart/summary/details/:summarySequence',
  MY_CHART_PAST_HISTORY = '/patients/my-chart/past-history',
  MY_CHART_PAST_HISTORY_HOSPITAL_DETAILS = '/patients/my-chart/past-history/:pastHistorySequence/hospital-detail',
  MY_CHART_PAST_HISTORY_PATIENT_DETAILS = '/patients/my-chart/past-history/:pastHistorySequence/patient-detail',
  MY_CHART_FORM_PAST_HISTORY = '/patients/my-chart/past-history/:pastHistorySequence/action/:typeAction',
  MY_CHART_PAST_HISTORY_INACTIVATE = '/patients/my-chart/past-history/inactivate',
  MY_CHART_VACCINES = '/patients/my-chart/vaccines',
  MY_CHART_VACCINE_DETAIL = '/patients/my-chart/vaccines/detail/:sequence',
  MY_CHART_MEDICINE = '/patients/my-chart/medicine',
  MY_CHART_FORM_MEDICINE = '/patients/my-chart/medicine/:medicineSequence/action/:typeAction',
  MY_CHART_MEDICINE_HOSPITAL_DETAILS = '/patients/my-chart/medicine/:medicineSequence/hospital-detail',
  MY_CHART_MEDICINE_PATIENT_DETAILS = '/patients/my-chart/medicine/:medicineSequence/patient-detail',
  MY_CHART_SEND_DOCUMENT = '/patients/my-chart/send-document',

  // UPLOAD
  UPLOAD_PREVIEW = '/preview',

  TASKS = '/patients/tasks',

  // Public scheduling actions
  PUBLIC_SCHEDULE_ACTIONS = '/public/scheduling-actions/type/:type/:token',
}
